export enum QuestAnswerType {
  TEXT = 'text',
  FILE = 'file',
  FILETEXT = 'filetext',
  AUTO = 'auto'
}

export enum QuestAnswerStatus {
  /**
   * Вопрос незавершён и в процессе выполнения
   */
  IN_PROGRESS = 'in_progress',
  /**
   * Вопрос незавершён, но пользователь может его исправить
   */
  IN_PROGRESS_FAILED = 'in_progress_failed',
  /**
   * Вопрос завершён и неправильно. Пользователь не может его исправить. Квест должен быть таким же статусом быть
   */
  FAILED = 'failed',
  /**
   * Вопрос завершён и правильно. Пользователь не может его исправить. Квест должен быть таким же статусом быть
   */
  COMPLETED = 'completed'
}

export enum QuestStatus {
  /**
   * Квест незавершён и в процессе выполнения
   */
  IN_PROGRESS = 'in_progress',
  /**
   * Вопрос незавершён и требуется проверка
   */
  IN_PROGRESS_TO_VERIFY = 'in_progress_to_verify',
  /**
   * Квест незавершён, но пользователь может его исправить
   */
  IN_PROGRESS_FAILED = 'in_progress_failed',
  /**
   * Квест завершён и неправильно. Пользователь не может его исправить
   */
  FAILED = 'failed',
  /**
   * Квест завершён и правильно. Пользователь не может его исправить
   */
  COMPLETED = 'completed',
  /**
   * Квест незавершён и пользовательно не может его исправить
   */
  CANCELLED = 'cancelled'
}

export const QuestStatusNotValid = [
  QuestStatus.IN_PROGRESS,
  QuestStatus.IN_PROGRESS_FAILED,
  QuestStatus.FAILED,
]

/**
 * Можно как-то по другому назвать, я пока хз
 */
export enum QuestEntryType {
  GIFT = 'gift',
  MONEYBOX = 'moneybox',
}
